/** @jsxRuntime classic */
/* @jsx jsx */
import { jsx } from "@emotion/react";
import facepaint from "facepaint";

// RESPONSIVENESS SETTINGS
const breakpoints = [900];
const mq = facepaint(breakpoints.map((bp) => `@media (min-width: ${bp}px)`));

export default function Album() {
  return (
    <div css={albumStyle}>
      <div className="empty" />
      <div className="albumDescription">
        <p className="sagrada">SAGRADA BENDICIÓN</p>
        <p className="disponible">Disponible el 17 de Octubre</p>
        <p className="plataformas">Todas las plataformas digitales</p>
        <a
          href="https://teana.bfan.link/SagradaBendicion"
          target="_blank"
          rel="noopener noreferrer"
        >
          Escúchalo
        </a>
      </div>
    </div>
  );
}

const albumStyle = mq({
  height: "100vh",
  backgroundImage: "url('/pictures/portada-sb.webp')",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center",
  backgroundSize: "cover",
  backgroundAttachment: "fixed",
  display: "grid",
  gridTemplateColumns: ["1fr", "1fr 1fr"],
  ".empty": {
    display: ["none", "block"],
  },
  ".albumDescription": {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    ".sagrada": {
      color: "var(--red)",
      fontSize: ["2rem", "2.5rem"],
      marginBottom: "1rem",
    },
    ".disponible": {
      fontSize: ["1.5rem", "2rem"],
      letterSpacing: "2px",
    },
    ".plataformas": {
      letterSpacing: "2px",
      marginBottom: "2rem",
    },
    a: {
      backgroundColor: "var(--red)",
      fontSize: ["1rem", "1.5rem"],
      padding: "1rem",
      borderRadius: "8px",
      letterSpacing: "2px",
      transition: "all 200ms ease-in-out",
      ":hover": {
        backgroundColor: "#a22407",
      },
    },
  },
  borderBottom: "1px solid white",
});
